import { usePriorityBadgeState } from 'components/Dashboard/ItemController/PriorityBadge';

const ContentPagePriorityBadge = ({ currentNew, numberOfContributions, showDot = true }) => {
  const feedItemFlags = currentNew?.feedItemFlags;
  const minRelevanceScore = import.meta.env.VITE_APP_PRIORITY_UPDATES_MIN_RELEVANCE_SCORE ?? 0.8;
  const priorityBadgeCondition =
    feedItemFlags?.relevanceScore >= minRelevanceScore && feedItemFlags?.importanceScore >= 0;
  const { setPriorityBadgeModalState } = usePriorityBadgeState();

  if (!priorityBadgeCondition) {
    return null;
  }

  const { matchingKeywordLists, sourceScore, noveltyScore, eventCountScore } = feedItemFlags ?? {};
  const itemData = {
    type: currentNew?.objectType,
    sourceScore,
    noveltyScore,
    eventCountScore,
    relevantContributions: numberOfContributions,
    matchingKeywordLists: matchingKeywordLists?.length,
    sourceOrganisation: currentNew?.sourceOrganisation,
    source: currentNew?.source,
  };

  return (
    <>
      {showDot && <span className='dot' />}
      <button
        type='button'
        className='general-button link-button text-light-blue mb-0 hover-opacity-85 transition-100'
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setPriorityBadgeModalState({ itemData, isOpen: true });
        }}
      >
        Priority update
      </button>
    </>
  );
};

export default ContentPagePriorityBadge;
